/*
|--------------------------------------------------------------------------
| Data: Validate: Bucket
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.data.validate.bucket = {
	/**
	 * Check to see if bucket has an ad
	 * @param  {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	"hasAd": function(bucket){
		return __gh__webApp.common.isObjectPropertySet(bucket,"ads.slot2.view");
	},


	/**
	 * Check to see if bucket has items
	 * @param {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	"hasItems": function(bucket){
		var items 		= bucket.items,
			commonJS 	= __gh__webApp.common;
		if(!items || commonJS.isObjectEmpty(items) || (("main" in items) &&  ("success" in items.main[0]) && items.main[0].success == false)){
			   /*debug.error("Bucket has no items",{
				   "title":bucket.title,
				   "feedURL": bucket.feedURL
			   });*/
			   return false;
		}
		return true;
	},


	/**
	 * Check to see if module has Twitter
	 * @param  {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	"hasTwitter": function(bucket){
		if("twitter" in bucket.view.options &&
		   !__gh__webApp.common.isObjectEmpty(bucket.view.options.twitter)) {return true;}
		return false;
	},


	/**
	 * Check to see if module has Children
	 * @param {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	"hasChildren": function(bucket){
		if(!__gh__webApp.common.isArrayEmpty(bucket.children)) {return true;}
		return false;
	},

	/**
	 * Check to see if bucket view has more headlines
	 * @param {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	"hasMoreHeadlines": function(bucket){
		var commonJS = __gh__webApp.common;
		if(!commonJS.isObjectPropertySet(bucket,"view.options.moreHeadlines")) {return false;}
		return bucket.view.options.moreHeadlines;
	},

	/**
	 * Check to see if bucket view has more headlines med rec ad
	 * @param {object} bucket - bucket object
	 * @return {boolean} - returns true or false
	 */
	 "hasMoreHeadlinesAd": function(bucket){
		return __gh__webApp.common.isObjectPropertySet(bucket,"ads.slot5.view");
	 }

};
